import { render, staticRenderFns } from "./ModelEkle.vue?vue&type=template&id=0131d9f8&scoped=true&"
import script from "./ModelEkle.vue?vue&type=script&lang=js&"
export * from "./ModelEkle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131d9f8",
  null
  
)

export default component.exports